<template>
  <div class="flex justify-center items-center min-h-screen text-gray-500">
    Signing out…
  </div>
</template>

<script>
import { actionTypes } from 'store/auth'

export default {
  name: 'Logout',
  async created() {
    await this.$store.dispatch(actionTypes.logout)
    this.$router.replace({ name: 'Login' })
  },
}
</script>
